import React from 'react'
import { BrowserRouter, Switch, Route } from 'react-router-dom'
import { routes } from 'Router/routes'
import WithoutAuth from './components/ContentBox/WithoutAuth'
import WrapperAuth from './components/Wrappers/WrapperAuth'
import AuthorizedWrapper from './components/Wrappers/AuthorizedWrapper'
import ErrorPage from 'components/Modules/ErrorPage/ErrorPage'

const App = () => {
  return (
    <BrowserRouter>
      <Switch>
        <Route
          path={routes.public.filter((r) => !r.wrapper).map((r) => r.path)}
        >
          <WithoutAuth />
        </Route>

        <Route
          path={routes.public
            .filter((r) => r.wrapper === 'WrapperUser')
            .map((r) => r.path)}
        >
          <WrapperAuth />
        </Route>

        <Route path='/' exact>
          <AuthorizedWrapper />
        </Route>

        {routes.private.map((r) => (
          <Route key={r.path} path={r.path}>
            <AuthorizedWrapper {...r} />
          </Route>
        ))}

        <Route path='*' exact component={ErrorPage} />
      </Switch>
    </BrowserRouter>
  )
}

export default App
